module.exports = __webpack_public_path__ + "static/media/location.d3894bbf.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/location.svg
// module id = 630
// module chunks = 0